import React from 'react';

const Services = () => {
    return (
        <div className='main'>
            <section className='services section' id='services'>
                <h1 className='section_title'>What I offer</h1>
                <div className="services_container container grid">
<div className="services_content">
    <div>
        
    </div>
</div>
                </div>
            </section>
        </div>
    );
};

export default Services;